import { Typography } from "antd";
import styled from "styled-components";

const MenuBackStyle = styled.div`
    display: flex;
    width: 100%;
    max-width: 900px;
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
    align-self: stretch;
    margin: 0 auto;
`;


const ContentText = styled(Typography.Text)`
    display: flex;
    align-items: center;
    gap: 8px;
    color: ${({ theme }) => theme?.colors?.text?.headings};
    text-align: center;
    font-feature-settings: 'liga' off, 'clig' off;
    font-family: "Red Hat Display", Arial;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: 120%;

`;
export {
    MenuBackStyle,
    ContentText
};

